import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserSearchingCriteria } from '@models/user';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PageResponse } from '@app/models/page-response';
import { userOne, userTwo } from './user.service.mock';
import { CommonService } from '@app/services/common.service';
import { AdminUser } from '@app/models/admin-user';


@Injectable()
export class MockAdminUserService {

   

    globalSearch(globalCriteria: string = '', criteria: UserSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<AdminUser>> {

        let pageResponse = new PageResponse<AdminUser>();
        pageResponse.content = [].concat(userOne).concat(userTwo);
        pageResponse.totalElements = 2;
        pageResponse.number = 0;
        pageResponse.size = 2;
        pageResponse.totalPages = 1;

        return of(pageResponse);

    }

    insert(user: AdminUser): Observable<AdminUser> {
        return of(user);
    }

    get(id: string): Observable<AdminUser> {
        return of(userOne)
    }

    update(user: AdminUser): Observable<AdminUser> {

        let body = JSON.stringify(user);

        return of(userOne)

    }

    findAll(): Observable<AdminUser[]> {
        return of([].concat(userOne).concat(userTwo))

    }



}